var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#55746e;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.003,348.768c12.848-115.627,86.282-211.197,185.781-257.238C268.378,53.37,236.62,22.365,199.921,0 C62.447,65.536-2.416,227.413,54.819,370.914c14.055,35.265,34.373,66.122,58.994,92.125 C104.455,425.92,101.726,387.261,106.003,348.768z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.482,93.253C287.34,86.361,153.924,198.646,136.859,352.197c-6.209,55.924,3.883,109.888,26.406,157.215 c2.134,0.289,4.225,0.63,6.35,0.866c152.43,16.933,289.722-92.903,306.654-245.325C483.17,202.836,469.01,143.23,439.482,93.253z  M290.952,345.279c-48.56,75.218-93.716,132.454-100.854,127.853c-7.119-4.609,26.484-69.305,75.078-144.515 c48.577-75.218,93.734-132.455,100.862-127.854C373.177,205.373,339.556,270.069,290.952,345.279z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.083ec19f0bf37bcc7d947b42821a9c15.svg";
export { ForwardRef as ReactComponent };